module.exports = __webpack_public_path__ + "static/media/chef-2.cee5d441.jpg";